import React from 'react';
import { useQuery } from '@tanstack/react-query';
import TodayDeliveryBadge from '../../../../../../../static/images/common/today_delivery_badge_icon.png';
import { setNumberWithComma } from '../../../../../../../lib/common';
import { TimedealWidgetItem } from '../../../../../../../types/widget';
import { PRODUCT } from '../../../../../../../constants/queryKeys';
import { productListFetcher } from '../../../../common/fetchers/productListFetcher';
import { TimedealImageStyle, TimedealProductCardInfoStyle, TimedealProductCardWrapper } from './style';

interface TimedealProductCardProps {
  widgetItem: TimedealWidgetItem;
}
const TimedealProductCard = (props: TimedealProductCardProps): JSX.Element => {
  const { widgetItem } = props;
  const { mobileImage, coupon, link } = widgetItem;

  const { data } = useQuery(
    [...PRODUCT.LIST, link?.id],
    () => productListFetcher({ id: link?.id, status: null, brandStatus: null }),
    {
      enabled: !!link?.id,
      select: (res) => res.list[0],
    },
  );

  return (
    <TimedealProductCardWrapper>
      <TimedealImageStyle src={mobileImage?.[0]?.url || ''} />
      {data && (
        <TimedealProductCardInfoStyle>
          <div className="product-info">
            <span className="store-name">{data.brandName}</span>
            <span className="product-name">{data.name}</span>
            <div className="price-info">
              {!!data.discountRate && <span className="discount-rate">{`${data.discountRate}%`}</span>}
              <span className="sales-price">{setNumberWithComma(data.salesPrice)}원</span>
              <span className="origin-price">{setNumberWithComma(data.originPrice)}원</span>
              {!!coupon && <span className="coupon-text">(쿠폰 적용가)</span>}
            </div>
            <div className="today-delivery">
              <img src={TodayDeliveryBadge} alt="오늘출발 뱃지" />
            </div>
          </div>
        </TimedealProductCardInfoStyle>
      )}
    </TimedealProductCardWrapper>
  );
};

export default TimedealProductCard;
